import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';

const CaseConverterTool = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');

  const convert = (type) => {
    if (!input.trim()) {
      toast.error('Please enter text to convert');
      return;
    }

    let result = '';
    switch (type) {
      case 'upper':
        result = input.toUpperCase();
        break;
      case 'lower':
        result = input.toLowerCase();
        break;
      case 'title':
        result = input.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
        break;
      case 'sentence':
        result = input.toLowerCase().replace(/(^\w|[.!?]\s+\w)/g, c => c.toUpperCase());
        break;
      case 'camel':
        result = input.toLowerCase()
          .replace(/[^a-zA-Z0-9]+(.)/g, (_, c) => c.toUpperCase());
        break;
      case 'pascal':
        result = input.toLowerCase()
          .replace(/(^|[^a-zA-Z0-9]+)(.)/g, (_, __, c) => c.toUpperCase());
        break;
      case 'snake':
        result = input.toLowerCase()
          .replace(/\s+/g, '_')
          .replace(/[^a-zA-Z0-9_]/g, '');
        break;
      case 'kebab':
        result = input.toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-zA-Z0-9-]/g, '');
        break;
      case 'constant':
        result = input.toUpperCase()
          .replace(/\s+/g, '_')
          .replace(/[^A-Z0-9_]/g, '');
        break;
      default:
        result = input;
    }
    setOutput(result);
  };

  const copyOutput = () => {
    if (output) {
      navigator.clipboard.writeText(output);
      toast.success('Copied!');
    }
  };

  const cases = [
    { id: 'upper', label: 'UPPERCASE' },
    { id: 'lower', label: 'lowercase' },
    { id: 'title', label: 'Title Case' },
    { id: 'sentence', label: 'Sentence case' },
    { id: 'camel', label: 'camelCase' },
    { id: 'pascal', label: 'PascalCase' },
    { id: 'snake', label: 'snake_case' },
    { id: 'kebab', label: 'kebab-case' },
    { id: 'constant', label: 'CONSTANT_CASE' },
  ];

  return (
    <div className="space-y-4" data-testid="case-converter-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">Case Converter</h3>
      </div>

      <Textarea
        placeholder="Enter your text here..."
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className="min-h-[100px] bg-background/50"
        data-testid="input"
      />

      <div className="grid grid-cols-3 gap-2">
        {cases.map((c) => (
          <Button
            key={c.id}
            variant="outline"
            size="sm"
            onClick={() => convert(c.id)}
            className="text-xs"
          >
            {c.label}
          </Button>
        ))}
      </div>

      {output && (
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Output</span>
            <Button variant="ghost" size="sm" onClick={copyOutput}>
              <Copy className="w-4 h-4 mr-1" /> Copy
            </Button>
          </div>
          <Textarea
            value={output}
            readOnly
            className="min-h-[100px] bg-background/50"
            data-testid="output"
          />
        </div>
      )}
    </div>
  );
};

export default CaseConverterTool;
